export * from './wixDataSettings';
export * from './datasetTypes';
export * from './readWriteModes';
export * from './bindingConfig';
export * from './cmsPublicAPI';
export var AppCollectionVisibility;
(function (AppCollectionVisibility) {
    AppCollectionVisibility["HIDDEN"] = "hidden";
    AppCollectionVisibility["VISIBLE"] = "visible";
})(AppCollectionVisibility || (AppCollectionVisibility = {}));
export var DynamicPageUrlValidationError;
(function (DynamicPageUrlValidationError) {
    DynamicPageUrlValidationError["URL_TOO_LONG"] = "URL_TOO_LONG";
    DynamicPageUrlValidationError["PREFIX_STARTS_WITH_TEXT"] = "PREFIX_STARTS_WITH_TEXT";
    DynamicPageUrlValidationError["NO_FIELD_IN_PREFIX"] = "NO_FIELD_IN_PREFIX";
    DynamicPageUrlValidationError["NO_SPECIAL_CHARS"] = "NO_SPECIAL_CHARS";
    DynamicPageUrlValidationError["NO_DELETED_FIELD"] = "NO_DELETED_FIELD";
    DynamicPageUrlValidationError["ONLY_EXISTING_FIELDS"] = "ONLY_EXISTING_FIELDS";
    DynamicPageUrlValidationError["PATTERN_ALREADY_EXISTS"] = "PATTERN_ALREADY_EXISTS";
    DynamicPageUrlValidationError["SEPARATE_FIELDS"] = "SEPARATE_FIELDS";
    DynamicPageUrlValidationError["UNSUPPORTED_FIELDS"] = "UNSUPPORTED_FIELDS";
    DynamicPageUrlValidationError["URL_EMPTY"] = "URL_EMPTY";
    DynamicPageUrlValidationError["NO_VARIABLE"] = "NO_VARIABLE";
    DynamicPageUrlValidationError["EXACT_PATTERN_EXISTS"] = "EXACT_PATTERN_EXISTS";
})(DynamicPageUrlValidationError || (DynamicPageUrlValidationError = {}));
//# sourceMappingURL=index.js.map